import { css } from '@emotion/react';
import { colors } from './colors';

const mixins = {
  scrollBar: css`
    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-track {
      background: transparent;
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      width: 8px;
      background-color: ${colors.gray3};
    }
  `,
};

export { mixins };
